class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');

    // Preorder variants must not add to cart directly — send the shopper to the
    // PDP so they see the preorder notification before purchasing.
    if (submitButton && submitButton.dataset.preorder === 'true' && submitButton.dataset.preorderUrl) {
      window.location.href = submitButton.dataset.preorderUrl;
      return;
    }

    this.cartNotification.setActiveElement(document.activeElement);

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
        if (submitButton && submitButton.classList.contains('membership_atc')) {
          if (document.documentElement.classList.contains('fm-ea-locked')) {
            window.location.reload();
            return;
          }
          const cm = window.FM && window.FM.cartMembership;
          if (cm && typeof cm.syncFromCart === 'function') cm.syncFromCart();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
